import { Outlet } from 'react-router-dom'
import React from 'react'

const UserLayout = () => {
  return (
    <div>
      <Outlet />
    </div>
  )
}

export default UserLayout
